import Link from "next/link";
import classNames from "classnames";
import { ReactNode } from "react";

interface ProfileMenuItemProps {
  selected: string | undefined;
  item: {
    id: string | undefined;
    name: string;
    icon: ReactNode;
    path: string;
    href: string;
  };
  onClick: () => void;
}

const ProfileMenuItem: React.FC<ProfileMenuItemProps> = ({
  selected,
  item,
  onClick,
}) => {
  const prepareLink =
    selected === "myCourse" ? `${item.href}?selected=myCourse` : item.href;
  const linkClassName = classNames(
    " relative flex rounded-l-8   gap-x-2 fds-sm:my-1 fds-sm:px-4     fds-sm:py-2 py-2.5 px-2   text-fds-primary cursor-pointer select-none items-center    ",
    selected === item.id
      ? "bg-fds-brand-light !text-fds-brand   border-r-2 border-fds-brand"
      : ""
  );
  return (
    <Link
      href={prepareLink}
      as={item.href}
      prefetch={false}
      className={linkClassName}
      onClick={onClick}
      target={item.id === "instructor" ? "_blank" : undefined}
    >
      {item.icon}
      <span
        className={classNames(
          "body-lg",
          selected === item.id ? " text-fds-brand " : ""
        )}
      >
        {item.name}
      </span>
    </Link>
  );
};

export default ProfileMenuItem;
